import { getUserMailboxInfo } from 'owa-client-ids';
import { ItemRouteParameters } from './calendarRoutes';
import { showReadingPaneWithPerf } from 'owa-calendar-reading-pane-actions';
import { setIsDeepLinkAction } from 'owa-calendar-actions/lib/actions/routingActions';
import {
    lazyShowFullComposeFromDeeplink,
    lazyShowFullComposeInEditMode,
} from 'owa-calendar-compose-form-store';
import EventScope from 'owa-service/lib/contract/EventScope';
import { FULL_COMPOSE_VIEW_TYPE_MODAL } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { logUsage } from 'owa-analytics';
import { getSourceQueryParam } from 'owa-querystring';
import { convertRestIdToEwsId } from 'owa-identifiers';

export interface EditRouteParameters {
    /**
     * Id of the item which should be edited
     */
    itemId: string;

    /**
     * Scope of the item that would be edited.
     * Could be: Default, ThisAndFollowingInstances, AllInstancesInSeries
     */
    eventScope?: string;
}

/**
 * The route handler for reading pane deeplink
 */
export async function itemRouteHandler(parameters: ItemRouteParameters) {
    // In case item Id is rest id, convert to EwsId.
    // If itemId is EWSId, then convertRestIdToEwsId returns the same id without any changes
    const id = convertRestIdToEwsId(parameters.itemId);
    const getSeriesMaster: boolean = parameters.showMaster == 'master';

    setIsDeepLinkAction(true);

    // TODO-zorauf VSO #28930: See if this needs to be handled for groups as well?
    return showReadingPaneWithPerf(
        { Id: id, mailboxInfo: getUserMailboxInfo() },
        'Deeplink',
        getSeriesMaster,
        true /* isDeeplink */
    );
}

/**
 * The route handler for edit deeplink
 */
export async function editRouteHandler(parameters: EditRouteParameters) {
    // In case item Id is rest id, convert to EwsId.
    // If itemId is EWSId, then convertRestIdToEwsId returns the same id without any changes
    const id = convertRestIdToEwsId(parameters.itemId);

    setIsDeepLinkAction(true);

    let eventScope = EventScope.Default;
    switch (parameters.eventScope) {
        case 'ThisAndFollowingInstances':
            eventScope = EventScope.ThisAndFollowingInstances;
            break;
        case 'AllInstancesInSeries':
            eventScope = EventScope.AllInstancesInSeries;
            break;
    }

    return lazyShowFullComposeInEditMode.importAndExecute(
        {
            ItemId: { Id: id, mailboxInfo: getUserMailboxInfo() },
        },
        eventScope,
        false /* itemHasUpdates */,
        'Deeplink_Edit',
        FULL_COMPOSE_VIEW_TYPE_MODAL,
        null /* extractionSourceId */
    );
}

/**
 * The route handler for compose form deeplink
 */
export async function composeRouteHandler() {
    setIsDeepLinkAction(true);
    logUsage('CalendarComposeRouteHandlerEvent', { source: getSourceQueryParam() });

    return lazyShowFullComposeFromDeeplink.importAndExecute();
}
